import type { PageField } from '~/pages/AskRichardUnified/page/pageContract';
import { validatePageFilters } from '~/pages/AskRichardUnified/page/pageFilters';

export const RM_EDITABLE_FIELDS: Record<string, PageField> = {
  view: { type: 'enum', values: ['monitor', 'detail'] },
  range: { type: 'enum', values: ['quarter', 'custom'] },
  from: { type: 'date' },
  to: { type: 'date' },
};

const queryKeys: Record<string, string> = { view: 'rm_view', range: 'rm_range', from: 'rm_from', to: 'rm_to' };

/** A page-chat edit is a patch: preserve every filter or date the request did not change. */
export function rmPageEditSearch(search: string, changes: Record<string, unknown>): string {
  validatePageFilters(changes, RM_EDITABLE_FIELDS);
  const next = new URLSearchParams(search);
  for (const [key, value] of Object.entries(changes)) {
    next.set(queryKeys[key], String(value));
  }
  return next.toString();
}
